import type { ZMPConfig } from '@/common/provider/zmp.types'

import { queryClient } from './query-client'

export const ZMP_SETTING_QUERY_KEY = ['useGetZMPSetting'] as const

export const DEFAULT_ZMP_SETTING: ZMPConfig = {
  appName: 'Softworld Việt Nam',
  menuCode: 'MENU001057',
  brandCode: 'SWOOD',
  store: {
    default: 'SWWOD',
  },
  zaloOA: '2138185689813256716',
  themes: {
    color_primary_brand: '#006eff',
    color_primary_on_brand: '#ffffff',
  },
  pages: {
    home_page: {
      builder: {
        name: 'Home',
        url: '/',
        order: 1,
        isActive: true,
        blocks: [],
      },
    },
  },
  locales: {
    'en-US': {
      appName: 'Softworld Vietnam',
    },
  },
}

export const getZMPSetting = (): ZMPConfig =>
  queryClient.getQueryData<ZMPConfig>(ZMP_SETTING_QUERY_KEY) ??
  DEFAULT_ZMP_SETTING
